import React from 'react';
import ReactDOM from 'react-dom/client';
import { ordiniAcquisto_interface } from '../interfaces/ordiniAcquisto_interface';
import DialogAsyncListaOrdini from '../components/DialogAsyncListaOrdini';

export function openDialogAsyncListaOrdini(
  listaOrdini: ordiniAcquisto_interface[]
): Promise<ordiniAcquisto_interface[]> {
  return new Promise((resolve) => {
    const div = document.createElement('div');
    document.body.appendChild(div);

    const root = ReactDOM.createRoot(div);

    const handleClose = (result: ordiniAcquisto_interface[]) => {
      root.unmount(); // Smonta il componente
      document.body.removeChild(div); // Rimuovi il nodo dal DOM
      resolve(result); // Risolvi la Promise con il risultato
    };

    root.render(
      <DialogAsyncListaOrdini listaOrdini={listaOrdini} onClose={handleClose} />
    );
  });
}
